import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ChevronLeft } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("popu-token", r.data.token);
      localStorage.setItem("popu-user", JSON.stringify(r.data.user));
      toast.success(`Bienvenido, ${r.data.user.name}`);
      navigate("/admin/dashboard");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error de login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "var(--bg)" }}>
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-1 text-sm font-semibold accent-text hover:underline mb-6">
          <ChevronLeft size={14} /> Volver
        </Link>
        <div className="text-center mb-8">
          <span className="popu-logo text-4xl">POPU<span className="dot-news accent-text">.news</span></span>
          <p className="overline mt-2" style={{ color: "var(--text-muted)" }}>PANEL EDITORIAL</p>
        </div>
        <form onSubmit={submit} className="space-y-4 p-8 border rounded-sm" style={{ borderColor: "var(--border)", background: "var(--surface)" }} data-testid="admin-login-form">
          <h1 className="font-headline text-2xl uppercase mb-2">Iniciar sesión</h1>
          <input
            data-testid="admin-email"
            type="email"
            required
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 rounded-sm border bg-transparent outline-none focus:border-[color:var(--accent)]"
            style={{ borderColor: "var(--border)" }}
          />
          <input
            data-testid="admin-password"
            type="password"
            required
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 rounded-sm border bg-transparent outline-none focus:border-[color:var(--accent)]"
            style={{ borderColor: "var(--border)" }}
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 accent-bg text-white font-bold uppercase tracking-widest text-sm rounded-sm hover:opacity-90 disabled:opacity-50"
            data-testid="admin-login-submit"
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
